import shareThis from 'share-this';
import * as facebookSharer from 'share-this/dist/sharers/facebook';
import * as emailSharer from 'share-this/dist/sharers/email';
import * as twitterSharer from './sharers/twitter';

export default () => {
  const sharers = [facebookSharer, twitterSharer, emailSharer];

  const selectionShare = shareThis({
    selector: '.c-main',
    sharers,
  });

  selectionShare.init();
};



// WEBPACK FOOTER //
// ./src/scripts/modules/share.js